import React from 'react';

type CreditBarProps = {
  creditsAvailable: number;
  creditsReserved: number;
  onTopUp: () => void;
};

const formatCredits = (value: number): string => {
  if (!Number.isFinite(value)) return '0';
  return value.toLocaleString();
};

const CreditBar: React.FC<CreditBarProps> = ({ creditsAvailable, creditsReserved, onTopUp }) => {
  return (
    <section className="rounded-[14px] border border-[#e2e5eb] bg-white px-[22px] py-[14px]">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex flex-wrap items-center gap-4 sm:gap-6">
          <div>
            <p className="font-mono text-[20px] font-bold text-[#0d9488]">{formatCredits(creditsAvailable)}</p>
            <p className="text-[12px] text-[#94a3b8]">Credits Available</p>
          </div>
          <div className="hidden h-7 w-px bg-[#e5e7eb] sm:block" />
          <div>
            <p className="font-mono text-[20px] font-bold text-[#d97706]">{formatCredits(creditsReserved)}</p>
            <p className="text-[12px] text-[#94a3b8]">Reserved</p>
          </div>
        </div>

        <button
          type="button"
          onClick={onTopUp}
          className="rounded-[10px] border border-[#e2e5eb] bg-white px-5 py-2.5 text-[13px] font-semibold text-[#475569] transition-colors hover:border-[#0d9488] hover:text-[#0d9488]"
        >
          Top Up Credits
        </button>
      </div>
    </section>
  );
};

export default CreditBar;

